export const strTo12Hours = (str) => {
  try {
    const [hours, minutes] = str?.split(':').map(Number) || [0,0];
    return format12Hours(hours, minutes);
  } catch (e) {
    console.log(e)
    return '00:00';
  }
}

export const strTo24Hours = (str) => {
  try {
    const newStr = str?.split(" ")[1];
    if(newStr) {
      const [hours, minutes] = newStr?.split(':').map(Number) || [0,0];
      return format24Hours(hours, minutes);
    }
  } catch (e) {
    console.log(e)
    return '00:00';
  }
}

export const format24Hours = (hours, minutes) => {
  return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
}

export const format12Hours = (hours, minutes) => {
  return `${(hours % 12 || 12)}:${minutes.toString().padStart(2, '0')} ${hours >= 12 ? 'PM' : 'AM'}`;
}

export const diffInMinutes = (str1, str2) => {
  const [hours1, minutes1] = str1?.split(':').map(Number) || [0,0];
  const [hours2, minutes2] = str2?.split(':').map(Number) || [0,0];
  const totalMinutes1 = hours1 * 60 + minutes1;
  const totalMinutes2 = hours2 * 60 + minutes2;
  return Math.abs(totalMinutes1 - totalMinutes2);
}


export const generateTimeOptions = () => {
  const times = [];
  for (let hour = 5; hour <= 11; hour++) {
    let dhour = hour.toString().padStart(2, '0');
    for (let minute of ["00", "30"]) {
      times.push({ value: `${dhour}:${minute}`, label: `${hour}:${minute} AM`});
    }
  }
  const hour = 12;
  let dhour = (hour + 12).toString().padStart(2, '0');
  for (let minute of ["00", "30"]) {
    times.push({ value: `${dhour}:${minute}`, label: `${hour}:${minute} PM`});
  }

  for (let hour = 1; hour <= 10; hour++) {
    let dhour = (hour + 12).toString().padStart(2, '0');
    for (let minute of ["00", "30"]) {
      if(hour === 10 && minute==="30") {
        continue;
      }
      times.push({ value: `${dhour}:${minute}`, label: `${hour}:${minute} PM`});
    }
  }

  return times.map((time, index) => (
    <option key={index} value={time.value}>{time.label}</option>
  ));
};

export const getTimeZones = () => {
  const now = new Date();

  return Intl.supportedValuesOf("timeZone").map((tz) => {
    // figure out offset now
    const formatter = new Intl.DateTimeFormat("en-US", {
      timeZone: tz,
      timeZoneName: "shortOffset",
    });
    const parts = formatter.formatToParts(now);
    const offset = parts.find((p) => p.type === "timeZoneName")?.value || "";

    return {
      value: tz,                   // store this in DB
      label: `(GMT${offset.replace("GMT", "")}) ${tz}`,
    };
  });
}